import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
  private _errText: any;

  constructor(
    private toastService: ToastService,
    private router: Router
  ) {}

  errorHandler(error: any): any {
    let errMsg = error.message ? error.message : error.status ? `${error.status}` : 'Server error. ';

    try {
      this._errText = error._body ? JSON.parse(error._body) : '';
      errMsg = this._errText.message ? this._errText.message : errMsg;
    } catch (e) {}

    console.error(error);

    if (error.status !== 401 && error.status !== 403) {
      this.toastService.showErrorToast(errMsg);
    }
  }
}
